<template>
  <div :class="searchResultClassName" data-scroll-element="true" ref="scrollWrapper">
    <div class="keyword-result-count-info" v-if="totalCount > 0">
      <div>
        <span class="search-result-txt">검색결과</span>
        <span class="dark-purple">{{totalCount}}</span>
      </div>

      <filter-list-for-device v-for="(filterItem, index) in filterObject.filterlist"
                              :key="'filter_' + index"
                              :filter-item="filterItem"
                              :filter-title="filterTitleMap[index] || filterItem.title"
                              :filter-index="index"
                              v-on:set-filter-query="setFilterQuery"
      />
    </div>
    <infinite-scroll-cell-list v-if="cellList.length > 0"
                               key="infinite-scroll-cell-list-all-content-list"
                               :cell-list="cellList"
                               :thumbnail-info="thumbnailInfo"
                               :container-class-name="getCellListContainerClassName"
                               v-on:load-more="loadMore"
                               :loading="isLoading"
    ></infinite-scroll-cell-list>
    <infinite-scroll-multi-band v-if="type === 'theme' && multiSectionList.length > 0"
                                key="infinite-multi-band"
                                :multi-section-list="multiSectionList"
                                v-on:load-more-editorpick="loadMoreEditorPick"
                               :loading="isLoading"
    ></infinite-scroll-multi-band>
  </div>
</template>

<script>
import InfiniteScrollCellList from '@/components/section/template/cell/InfiniteScrollCellList'
import { EventService, SearchService } from '@/common/api/api.service'
import { getBandTypeInfoByCellType } from '@/common/image.util'
import { get, merge } from 'lodash'
import { mapMutations } from 'vuex'
import InfiniteScrollMultiBand from '@/components/section/template/cell/InfiniteScrollMultiBandList'
import FilterListForDevice from '@/components/section/template/FilterListForDevice'
import EventModelClass from '@/common/model/EventModelClass'
import MultiSectionModel from '@/common/model/MultiSectionModel'
import { parse } from 'query-string'
import { PATH_NAME_SEARCH, PATH_NAME_SEARCH_TAG } from '@/common/router.const'
import { EventBus } from '@/components/eventbus/EventBus'
import { SEARCH_EDITORPICK } from '@/common/utils/eventbus.const'
export default {
  name: 'SearchResultList',
  props: {
    type: {
      type: String
    },
    keyword: {
      type: String
    },
    mType: {
      type: String
    },
    tagSearchList: {
      type: Array,
      default: function () {
        return []
      }
    },
    isNavTab: {
      type: Boolean,
      default: true
    }
  },
  components: {
    InfiniteScrollMultiBand,
    InfiniteScrollCellList,
    FilterListForDevice
  },
  data () {
    return {
      offset: 0,
      limit: 20,
      editorPickLimit: 5,
      showEmptyList: false,
      endOfList: false,
      cellList: [],
      multiSectionList: [],
      thumbnailInfo: {},
      totalCount: 0,
      isLoading: false,
      filterTitleMap: {},
      filterObject: {},
      filterQueryMap: undefined,
      currentEvent: {}

    }
  },
  methods: {
    ...mapMutations([ 'showNavigationMenu', 'hideNavigationMenu' ]),
    loadMore () {
      if (this.endOfList) return
      if (this.isLoading) return
      const eventInstance = new EventModelClass(this.currentEvent)
      eventInstance.filter = this.filterQueryMap
      eventInstance.offset = this.offset
      eventInstance.limit = this.limit
      eventInstance.setPaging(true)
      this.setData(eventInstance)
    },
    loadMoreEditorPick () {
      if (this.endOfList) return
      if (this.isLoading) return
      this.setEditorPickData()
    },
    setFilterQuery ({ queryString, selectedTitle, filterIndex }) {
      this.cellList = []
      this.offset = 0
      this.endOfList = false
      this.filterTitleMap[filterIndex] = selectedTitle
      this.orderby = queryString !== '' ? queryString.split('=').pop() : 'score'
      this.filterQueryMap = merge(this.filterQueryMap, parse(queryString))
      const eventInstance = new EventModelClass(this.currentEvent)
      eventInstance.filter = this.filterQueryMap
      this.setData(eventInstance)
    },
    setEditorPickData () {
      SearchService.keywordSearchCF({
        keyword: this.keyword,
        orderby: this.orderby,
        limit: this.editorPickLimit,
        offset: this.offset,
        type: this.type,
        requestId: 'search-by-keyword'
      }).then(({ data }) => {
        if (this.offset === 0) {
          this.totalCount = get(data, 'totalcount', '0')
        }
        const resMultiSectionList = get(data, 'multisectionlist', []).map((multiSection) => {
          return new MultiSectionModel(multiSection)
        })
        if (resMultiSectionList.length === 0) {
          this.endOfList = true
        }
        this.showEmptyList = +this.totalCount === 0 && resMultiSectionList.length === 0
        this.offset += this.editorPickLimit
        this.multiSectionList = this.multiSectionList.concat(resMultiSectionList)
        this.loading = false
      })
    },
    setData (eventInstance) {
      if (this.isLoading) return
      this.isLoading = true
      if (get(this.$route, 'name', '').indexOf('tag') > -1) {
        eventInstance.method = 'post'
        eventInstance.data = { searchtags: this.tagSearchList }
      }
      EventService.requestEventData(eventInstance).then(({ data }) => {
        if (this.offset === 0) { // INFO : 처음에만
          this.totalCount = parseInt(get(data, ['cell_toplist', 'totalcount'], 0))
          this.filterObject = get(data, 'filter', {})
          this.subType = get(data, 'sub_type', '')
          this.titleList = get(data, ['cell_toplist', 'title_list'], [])
          this.topButtonList = get(data, ['cell_toplist', 'topbuttonlist'], [])
          this.thumbnailInfo = getBandTypeInfoByCellType(get(data, ['cell_toplist', 'cell_type'], ''))
          if (get(this.filterObject, 'filterlist', []).length > 0) {
            this.hasFilter = true
          }
          EventBus.$emit(SEARCH_EDITORPICK, { titleList: this.titleList, topButtonList: this.topButtonList })
        }
        this.filterQueryMap = this.filterQueryMap === undefined
          ? parse(get(this.filterObject, 'default_api_parameters', {}))
          : this.filterQueryMap
        let resCellList = get(data, ['cell_toplist', 'celllist'], [])
        this.showEmptyList = this.cellList.length === 0 && resCellList.length === 0
        if (resCellList.length === 0) { this.endOfList = true }
        this.offset += this.limit
        this.cellList = this.cellList.concat(resCellList)
        this.isLoading = false
      }).catch(() => {
        this.$router.replace('/')
      })
    },
    reset () {
      this.offset = 0
      this.limit = 20
      this.showEmptyList = false
      this.endOfList = false
      this.cellList = []
      this.multiSectionList = []
      this.thumbnailInfo = {}
      this.totalCount = 0
      this.orderby = 'score'
    }
  },
  computed: {
    getCellListContainerClassName () {
      return `cell-list responsive cell-${this.thumbnailInfo.type}`
    },
    searchResultClassName () {
      let className = ''
      if (get(this.$route, 'name', '') !== PATH_NAME_SEARCH) {
        className = 'search-wrapper search-list with-tag-list'
        if (get(this.$route, 'name', '') === PATH_NAME_SEARCH_TAG) className += ' with-tag-refresh'
      }
      return className
    }
  },
  created () {
    const url = get(this.$route, 'query.url', '')
    if (!this.isNavTab) this.hideNavigationMenu()
    if (url !== '') {
      const eventInstance = new EventModelClass({ url: decodeURIComponent(url) })
      this.currentEvent = eventInstance
      this.setData(eventInstance)
    } else {
      this.setEditorPickData()
    }
  },
  watch: {
    tagSearchList () {
      this.reset()
      this.setData(this.currentEvent)
    }
  }
}
</script>
<style scoped>
  .keyword-search-result-list {
    position: relative;
    width: 100%;
    height: 100%;
    padding-top: 56px;
  }
  .keyword-search-result-list.with-tag-refresh{
    padding-top: 162px;
  }
  .keyword-result-count-info {
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 100%;
    padding: 14px 10px;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #a5a5a5;
  }
  .search-result-txt{
    margin-right: 4px;
    color: #fff;
  }
  .empty-cell-list{
    padding-top: 72px;
  }
  .empty-cell-list .attention-mark-area {
    height: 50px;
    width: 50px;
    position: relative;
    margin: 0 auto;
  }
  .empty-cell-list .text-area {
    text-align: center;
    margin-top: 16px;
    color: #a5a5a5;
    font-size: 14px;
    line-height: 20px;
  }
  .keyword-color {
    color: #3887ff;
  }
</style>
